import {PageOptions} from '@graphcommerce/framer-next-pages'
import {ProductListDocument, ProductListQuery} from '@graphcommerce/magento-product'
import {StoreConfigDocument} from '@graphcommerce/magento-store'
import {GetStaticProps, LayoutHeader, MetaRobots, PageMeta} from '@graphcommerce/next-ui'
import {LayoutNavigation, LayoutNavigationProps, RowProduct, RowRenderer} from '../components'
import {LayoutDocument} from '../components/Layout/Layout.gql'
import getRevalidateTime from '../constants'
import {DefaultPageDocument, DefaultPageQuery} from '../graphql/DefaultPage.gql'
import {graphqlSharedClient, graphqlSsrClient} from '../lib/graphql/graphqlSsrClient'

type Props = DefaultPageQuery & {
    latestList: ProductListQuery
    favoritesList: ProductListQuery
    swipableList: ProductListQuery
}
type RouteProps = { url: string }
type GetPageStaticProps = GetStaticProps<LayoutNavigationProps, Props, RouteProps>

function Conditions(props: Props) {

    return (
        <div style={{
            width: '90%',
            marginTop: '100px',
            maxWidth: '900px',
            margin: '0 auto',
        }}>
            <h2>COME ORDINARE</h2>
            <p>

                Gli ordini possono essere inviati tramite la procedura automatica presente sul sito, utilizzando i
                listini on-line.

                Tutte le informazioni necessarie per i Vostri ordini potranno essere richieste al numero verde

                numero verde 800603309

                oppure al ns. indirizzo e-mail: info@jode.it

                La società si riserva di non accettare ordini che non rispettino le CONDIZIONI DI VENDITA.
            </p>
            <h2> OPZIONI DI SPEDIZIONE</h2>


            <h3>Tempi di consegna</h3>

            <p>Per ogni articolo sono indicati i tempi di consegna, che sono puramente indicativi e non vincolanti.
                I termini di consegna sono indicativi e non tassativi. Eventuali ritardi di consegna dovuti ai fornitori della merce 
                non possono causare l'annullamento dell'ordine, pretese in denaro e/o deduzioni sul prezzo concordato. Al
                Vs.ordine seguirà una nostra conferma ufficiale. Si consiglia di attendere la Ns.conferma prima di
                effettuare qualsiasi tipo di pagamento.</p>

            <h3>Trasporto</h3>

            <p>Trasporto compreso nel prezzo per ordini on-line per importi superiori a Euro 300,00 + IVA e per
                destinazioni nel territorio nazionale (isole escluse).
                La società venditrice si riserva di richiedere al momento dell'ordine un contributo spese di trasporto
                per
                isole o zone disagiate.</p>

            <p>
                Per ordini inferiori a Euro 300,00 + IVA verrà richiesto un contributo spese di spedizione di Euro 20,00
                +
                IVA
            </p>

            <p>
                La merce viaggia con regolare fattura accompagnatoria e viene spedita a mezzo corriere nazionale, con
                consegna esclusivamentea piano strada. Si può effettuare servizio di consegna al piano su richiesta, e
                con
                addebito del relativo costo.
            </p>

            <p>
                N.B: il montaggio non è mai compreso nel prezzo, ed è effettuabile su richiesta solo in alcune zone
                d'Italia
                dove abbiamo disponibilità di montatori. Rivolgersi al nostro Ufficio Commerciale per ulteriori
                informazioni.
            </p>

            <h3>Importante</h3>

            <p>Al momento della consegna del materiale da parte del corriere controllare SEMPRE che il numero dei colli
                sia
                quello indicato nel documento e che gli imballi siano integri. Nel caso in cui venisse riscontrata una
                mancanza o un danno negli imballi, accettare la merce CON RISERVA indicando nella bolla del corriere il
                problema riscontrato.</p>

            <p>>La merce viaggia a rischio e pericolo del committente, anche se convenuta franco destinazione.</p>


            <p>
                SENZA ANNOTAZIONE DI RISERVA INDICANTE IL PROBLEMA NON SI POTRA'PROCEDERE NE' ALLA SOSTITUZIONE NE'AL
                RISARCIMENTO DEL DANNO, COME DA NORMATIVA VIGENTE.
            </p>


            <h2>
                PAGAMENTI
            </h2>


            <p>Non effettuare pagamenti fino a che non avrete ricevuto la ns. conferma d'ordine.</p>

            <p>La società venditrice si riserva di richiedere un acconto per ordini di importo elevato o per gli
                articoli
                che vengono prodotti appositamente per il cliente .
            </p>

            <h3>BONIFICO BANCARIO ANTICIPATO</h3>


            <p>Il pagamento dovrà essere intestato a JUMBOFFICE S.R.L. e effettuato anticipatamente alla consegna previa
                ricezione conferma d'ordine con indicato le coordinate bancarie.</p>


            <p>Indicare sempre sulla casuale il nome e il numero della ns. conferma d'ordine.</p>

            <h3>NEXI - Pay By Link</h3>

            <p>Al momento della nostra conferma d’ordine definitiva vi verrà inviato un link tramite mail, sms o chat per effettuare il pagamento tramite carta di credito o bancomat. Il pagamento è garantito dal circuito sicuro Nexi, ed è come se pagaste direttamente al Pos presso la nostra sede.</p>

            <h3>CONTRASSEGNO</h3>

            <p>Il contrassegno è un metodo di pagamento di beni acquistati a distanza che consente di pagare
                l'oggetto(i)
                non in anticipo ma al momento del suo arrivo a destinazione, direttamente al corriere.</p>

            <p>Se non pattuito diversamente con la società venditrice, il pagamento della merce da parte Vostra deve
                essere
                effettuato esclusivamente attraverso una forma di pagamento "garantito" (contanti o assegno circolare).
                Per ogni ordine viene applicato sull’importo totale dell’acquisto il Diritto di Contrassegno pari al 2%
                del
                totale dell'ordinato.</p>

            <h3>CONTRASSEGNO CON RITIRO PRESSO LA NS.SEDE DI CALENZANO (FI)</h3>

            <p>Se il materiale ordinato viene ritirato direttamente da Voi presso il ns.punto vendita di Calenzano
                (Firenze).Presso il negozio potrete pagare in contanti, assegno, oppure con bancomat o carte di credito
                del
                circuito Visa.</p>


            <h2>SCAMBI E RESI</h2>


            <h3>Diritto di recesso:</h3>

            <p> La normativa sulle vendite dei prodotti via internet (art. da 50 al 68 del Codice del Consumo) prevede a
                favore del Consumatore il diritto di recedere dai contratti o dalle proposte contrattuali, garantendogli
                il
                diritto di restituire il prodotto acquistato e di ottenere il rimborso della spesa sostenuta. Il diritto
                di
                recesso è riservato esclusivamente ai consumatori privati che acquistano beni per scopi non legati alla
                propria attività professionale, commerciale o imprenditoriale. Le spese di restituzione del prodotto
                sono a
                carico del cliente. Il diritto di recesso non può essere esercitato per tutti i “beni confezionati su
                misura
                o chiaramente personalizzati” (così recita la legge sul diritto di recesso). Per esercitare il diritto
                di
                recesso è necessario comunicare alla ditta Jodè-Jumboffice S.r.l. entro 14 giorni lavorativi dal
                ricevimento
                della merce, la volontà di recedere dal contrattocon le seguenti modalità: invio di una lettera
                raccomandata
                con ricevuta di ritorno all'indirizzo Jodè-Jumboffice S.r.l.-Via V.Emanuele,19-50041 Calenzano (Fi) . E'
                possibile anche comunicare la volontà di voler recedere via fax al n.055/8879134 o al nostro indirizzo
                di
                posta elettronica info@jumboffice.it . Successivamente alla comunicazione di recesso, il cliente
                provvederà
                a spedire a proprie spese il prodotto accuratamente imballato nella confezione originale e completo di
                ogni
                accessorio.Jode' provvederà al rimborso dei prodotti entro 15 giorni una volta controllata l'integrità
                degli
                stessi. Il rimborso viene effettuato tramite bonifico bancarionel numero di conto corrente fornito dal
                cliente.</p>


            <h3>Garanzie</h3>

            <p>Ai sensi del D.Lgs 206/2005 ("Codice del Consumo") tutti i mobili e complementi d'arredo in vendita nel
                sito
                JODE' sono coperti dalla Garanzia Legale di 24 mesi. Per i titolari di partita iva non è valida la
                garanzia
                legale ma rimane valida la garanzia commerciale che può variare da 12/24 mesi in dipendenza dell'azienda
                acquistata. La garanzia legale prevede la responsabilità nei confronti del consumatore per i difetti di
                conformità non riscontrabili al momento dell'acquisto. In caso di difetto di conformità il consumatore
                ha
                diritto al ripristino, senza spese, della conformità del bene mediante riparazione o sostituzione (art.
                130
                del Codice del Consumo). Il consumatore può chiedere al venditore di riparare il bene o di sostituirlo,
                senza spese in entrambi i casi, salvo che il rimedio richiesto sia oggettivamente impossibile o
                eccessivamente oneroso rispetto all'altro. Le riparazioni o le sostituzioni devono essere effettuate
                entro
                un congruo termine dalla richiesta da parte del consumatore.
                Tempi e modalità di esercizio della Garanzia Legale. Il Cliente dovrà:
                Inviare una comunicazione scritta con la documentazione fotografica a Jode' indicando il vizio del
                prodotto;
                Jodè, appena accertato il difetto del prodotto, provvederà ad attivare la procedura per il reintegro del
                pezzo o componente difettoso. La società esclude qualunque garanzia laddove si riscontri che il vizio
                derivi
                da colpa, negligenza, imperizia o imprudenza del cliente. La Società non sarà responsabile qualora i
                vizi, i
                difetti od i guasti siano stati determinati dal comportamento scorretto del cliente; la garanzia non è
                valida anche quando il prodotto risulta rovinato a causa dell'utilizzo di prodotti non idonei per la
                pulizia
                o da un'errata installazione.</p>
        </div>
    )
}

Conditions.pageOptions = {
    Layout: LayoutNavigation,
} as PageOptions

export default Conditions

export const getStaticProps: GetPageStaticProps = async ({locale}) => {
    const client = graphqlSharedClient(locale)
    const staticClient = graphqlSsrClient(locale)

    const conf = client.query({query: StoreConfigDocument})
    const page = staticClient.query({query: DefaultPageDocument, variables: {url: `page/home`}})
    const layout = staticClient.query({query: LayoutDocument})

    // todo(paales): Remove when https://github.com/Urigo/graphql-mesh/issues/1257 is resolved
    const favoritesList = staticClient.query({
        query: ProductListDocument,
        variables: {pageSize: 8, filters: {category_uid: {eq: 'Mg=='}}},
    })

    const latestList = staticClient.query({
        query: ProductListDocument,
        variables: {pageSize: 8, filters: {category_uid: {eq: 'Mg=='}}},
    })

    const swipableList = staticClient.query({
        query: ProductListDocument,
        variables: {pageSize: 8, filters: {category_uid: {eq: 'Mg=='}}},
    })

    if (!(await page).data.pages?.[0]) return {notFound: true}

    const revalidate = getRevalidateTime()

    return {
        props: {
            ...(await page).data,
            ...(await layout).data,
            latestList: (await latestList).data,
            favoritesList: (await favoritesList).data,
            swipableList: (await swipableList).data,
            apolloState: await conf.then(() => client.cache.extract()),
        },
        revalidate,
    }
}
